import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { Utils } from 'app/components/utils/Utils';
import { ParameterCart } from 'app/models/cart-model';
import { StepModel } from 'app/models/step-model';
import { AppService } from 'app/services/app/app.service';
import { LanguageService } from 'app/services/language/language.service';
import { EventsService } from 'app/services/events/events.service';
import { combineLatest, Observable, Subject, Subscription, takeUntil } from 'rxjs';
import { StockPromotionModel } from 'app/models/stock-promotion-model';
import { StockModel, Subscription as StockSubscription, Type, UniquePrice } from 'app/models/stock-model';


@Component({
    selector: 'app-locker-date',
    templateUrl: './locker-date.page.html',
    styleUrls: ['./locker-date.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LockerDatePage implements OnInit, OnDestroy {

  parameters: ParameterCart;
  minPrice: number;
  
  activeSection:string = '';
  stock:StockModel;
  subscriptions: StockSubscription[] = [];
  uniquePrice: UniquePrice = null;
  private destroy$ = new Subject<void>()
  currentStock$: Subscription;
  
  constructor(
    private appService: AppService,
    private router: Router,
    private language: LanguageService,
    private route: ActivatedRoute,
    private eventsService: EventsService
  ) {}

  ngOnInit() {
    this.parameters = Utils.getParams(this.route.snapshot.queryParamMap);
    this.setNextBt(0, false);

    this.eventsService.subscribe('callNext', result => {
      this.goReserve();
    });

    combineLatest(
      {
          stock: this.appService.currentStock$,
          price: this.appService.currentPrice$
      } as {stock: Observable<StockModel>, price: Observable<StockPromotionModel>}
      ).pipe(takeUntil(this.destroy$))
      .subscribe(({ stock, price }) => {
        this.stock = stock;
        this.updateSelectedTypeData();
        this.minPrice = price.minPrice;
        this.setNextBt(this.minPrice, this.hasAvailability(price));
      });

      this.currentStock$ = this.appService.currentStock$.subscribe((stock:StockModel)=>{
            this.stock = stock;
            this.updateSelectedTypeData();
      });

  }

  ngOnDestroy() {
   this.eventsService.destroy('callNext');
   this.currentStock$?.unsubscribe();
   this.destroy$.next();
   this.destroy$.complete();
  }
  

  callBack({parameters, caller}: {parameters: ParameterCart, caller:any}) {
    this.parameters = parameters;
    this.updateSelectedTypeData();
    if(caller){
      this.activeSection = caller;
    }
    this.eventsService.publish('calculatorStep2', this.parameters);
  }

  setNextBt(total:number, next:boolean){
    let totalSrt = total != 0 ? ' ' +  total + '€' : '';
    this.eventsService.publish('refreshStep', {
      title: "2/4",
      nameBt: this.appService.getTraduccion('reserve.next') + totalSrt,
      next: next
    } as StepModel);
  }

  private hasAvailability(price: StockPromotionModel): boolean {
    return Object.keys(price?.items ?? {})
      .some(key => price.items[key]?.available > 0);
  }

  goReserve() {
    console.log("parameters", this.parameters);
        //  let url = this.parameters.type == 'KEY' ? '/reserve/checkout' : '/reserve/locker-size'
        //  let url = '/reserve/locker-size'
    this.router.navigate([this.language.path('reserve'), this.appService.kiosk, 'locker-size'], { queryParams: Utils.generateParams(this.parameters) })
  }

  private updateSelectedTypeData(): void {
    if (!this.stock?.items?.length || !this.parameters?.type) {
      this.subscriptions = [];
      this.uniquePrice = null;
      return;
    }

    const item: Type = this.stock.items.find(i => String(i.id) === String(this.parameters.type));

    this.subscriptions = item?.subscriptions ?? [];
    this.uniquePrice = item?.uniquePrice ?? null;
    this.syncActiveSection();
  }

  private syncActiveSection(): void {
    const hasReservation = this.uniquePrice != null;
    const hasSubscription = this.subscriptions.length > 0;

    if (!hasReservation && hasSubscription) {
      this.activeSection = 'subscription';
      this.parameters.paymentFrequency = 'RECURRENT';
      return;
    }

    if (hasReservation && !hasSubscription) {
      this.activeSection = 'reservation';
      this.parameters.paymentFrequency = 'UNIQUE';
      return;
    }

    if (!this.activeSection) {
      this.activeSection = hasReservation ? 'reservation' : 'subscription';
    }

    if (this.activeSection === 'subscription' && !hasSubscription) {
      this.activeSection = 'reservation';
    } else if (this.activeSection === 'reservation' && !hasReservation) {
      this.activeSection = 'subscription';
    }

    this.parameters.paymentFrequency = this.activeSection === 'subscription' ? 'RECURRENT' : 'UNIQUE';
  }
  
}
